"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function stateId(state) {
    if (state === void 0) { state = 0; }
    return state + 1;
}
exports.default = stateId;



//////////////////
// WEBPACK FOOTER
// ../~/dnd-core/lib/cjs/reducers/stateId.js
// module id = 2009
// module chunks = 1